import React from 'react';
import parse from 'html-react-parser';

import classes from './Tabs.module.pcss';
import {OfferingsType} from '../ServicesOfferings';

interface Props {
    activeTab: number,
    tabClickHandler: Function,
    eventCallback: Function,
    offerings: Array<OfferingsType>
}

const Tabs = ({offerings, activeTab, tabClickHandler, eventCallback}: Props) => (
    <div className={classes.Tabs}>{offerings?.map((item, index) =>
        <strong
            className={`${classes.Tab} ${activeTab === index ? classes.Active : ''}`}
            onClick={() => {
                tabClickHandler(index);
                eventCallback(parse(item?.offeringButtonTitle || ''));
            }}
            key={index}>{parse(item?.offeringButtonTitle || '')}
        </strong>
    )}</div>
);

export default Tabs;
